import {storeInstance} from '@aofl/store/dist/legacy';
import {deepAssign} from '@aofl/object-utils';
import {sdoNs} from '../constants-enumerate';

const sdo = {
  namespace: sdoNs.SUPPORT_WIDGET,
  mutations: {
    init() {
      return {
        showForm: false,
      };
    },
  },
  decorators: [
    (nextState) => { // $loadAdaWidget
      const state = storeInstance.getState();
      let $loadAdaWidget = false;
      const nonWidgets = [149484, 164977, 225767, 240506];

      if (state[sdoNs.SESSION] !== nextState[sdoNs.SESSION]) {
        $loadAdaWidget = !nonWidgets.includes(nextState[sdoNs.SESSION].group_info.root_id);
        nextState = deepAssign(nextState, sdoNs.SUPPORT_WIDGET, {
          $loadAdaWidget
        });
      }
      return nextState;
    }
  ]
};

storeInstance.addState(sdo);
